function toPositionPercents(position) {
  return `${position[0]}%_${position[1]}%`;
}

export default toPositionPercents;
